// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"7a0e1dbd","52":"2ae227cf","71":"6400f24e","92":"fc94920c","102":"550091a7","131":"3e1e727b","269":"79dbb403","701":"f96a1529","768":"e112eedc","822":"c8433d53"}[chunkId] + ".chunk.js";
};